<div
  class="review-workflow-entry w-100 d-flex p-3"
  *ngIf="changeRequestJsonWorkflow">
  <div class="flex-grow-1 mw-70">
    <div
      class="w-100 px-3"
      *ngIf="showDiff && activeWorkflowData; else rawWorkflowView">
      <irembogov-json-diff-viewer
        sectionTitle="Workflow Changes"
        [oldData]="activeWorkflowData"
        [newData]="changeRequestJsonWorkflow"
        viewMode="side-by-side">
      </irembogov-json-diff-viewer>
    </div>
    <ng-template #rawWorkflowView>
      <div class="w-100 px-3">
        <pre
          class="border bg-white overflow-auto w-100 p-3"
          [innerHTML]="
            changeRequestJsonWorkflow | prettyjson : { escapeHtmlBracket: true }
          "
          *ngIf="changeRequestJsonWorkflow"></pre>
      </div>
    </ng-template>
  </div>
  <irembogov-reviewer-issues-entry-form-widget
    class="justify-self-end w-30"
    [changeRequestId]="changeRequest.id"
    [reviewSection]="EServiceChangeRequestReviewSection.WORKFLOW"
    (goToNext)="
      reviewWorkflowJsonCompleted.emit($event)
    "></irembogov-reviewer-issues-entry-form-widget>
</div>
